const updateStaffScore = () =>
  import('@/views/main/order/update-staff-score/update-staff-score.vue')
export default {
  path: '/main/order/updateStaffScore',
  name: 'updateStaffScore',
  component: updateStaffScore,
  children: []
}
